import apiClient from 'src/utils/apiClient';
import { TOAST_TIMEOUT } from 'src/config/Toast';
import store from 'src/store';
import { createToast } from 'src/store/toastsSlice';

// TODO migrate Region specific calls from TaskService into this class
class RegionService {
  public async downloadListJobsWithTaskRequirementsByRegion(regionId: number) {
    const res = await apiClient.get(`/regions/${regionId}/jobRequirementsReport`, {
      responseType: 'blob',
    });
    if (res) {
      store.dispatch(
        createToast({
          type: 'success',
          message: 'Downloaded Jobs Summary successfully',
          timeout: TOAST_TIMEOUT,
        }),
      );
    }
    return res;
  }
}

export default new RegionService();
